import { cx } from 'cvb';
import PropTypes from 'prop-types';
import { BodyCopy } from '../ui/BodyCopy/BodyCopy';
import { badgesStyles } from './Badges.style';
import { stickersStyles } from './Stickers.style';

export const Badges = ({ badgeItems, deviceType, layout, isSticker, isEventSticker }) => {
  const getBadgeSize = () => {
    if (deviceType === 'mobile') {
      return layout.indexOf('PDP') !== -1 ? 'copy4' : 'copy7';
    }
    return 'copy8';
  };

  const getBadgeStyles = (badge) => {
    return {
      backgroundColor: badge.styles.backgroundColor,
      color: badge.styles.textColor,
    };
  };

  return (
    <div
      className={cx(
        layout !== 'LIST' && isSticker && 'meatstickers',
        layout === 'LIST' && !isEventSticker && `pod-badges pod-badges-${layout}`,
        (isSticker || isEventSticker) && 'sticker-group',
        isEventSticker && layout === 'LIST' && deviceType === 'mobile' && 'list-mobile-event',
        isEventSticker && layout === 'LIST' && deviceType === 'desktop' && 'list-desktop-event'
      )}
    >
      {badgeItems?.map((badge) => (
        <BodyCopy size={getBadgeSize()} key={badge.label} isHighlighted>
          {() => {
            const newBadgeLabel = badge?.label?.replace('<b>', '<b style="font-weight:700">');

            return (
              newBadgeLabel && (
                <span
                  id={`testId-Pod-badges-${badge.type}`}
                  className={`pod-badges-item-${layout} pod-badges-item ${
                    badge.type === 'event' ? 'event-sticker-bold' : ''
                  }`}
                  style={getBadgeStyles(badge)}
                  dangerouslySetInnerHTML={{ __html: newBadgeLabel }}
                />
              )
            );
          }}
        </BodyCopy>
      ))}
      <style jsx>{badgesStyles}</style>
      <style jsx>{stickersStyles}</style>
    </div>
  );
};

Badges.propTypes = {
  badgeItems: PropTypes.array,
  deviceType: PropTypes.oneOf(['mobile', 'tablet', 'desktop']).isRequired,
  layout: PropTypes.string,
  isSticker: PropTypes.bool,
  isEventSticker: PropTypes.bool,
};

Badges.defaultProps = {
  badgeItems: [],
  layout: '',
  isSticker: false,
  isEventSticker: false,
};
